import React, { JSX, useContext } from "react";
import { PciDashboardSummaryType } from "@app/projects/network-assessment/pci-dashboard/shared";
import { ProviderNetworkTypeEnum } from "@app/shared/enums/providerNetworkTypeEnum";
import { ClaimsInsightsDashboardContext } from "@app/projects/network-assessment/pci-dashboard/claims-insights/ClaimsInsightsDashboardContext";
import ClaimsInsightsProvidersTile from "@app/projects/network-assessment/pci-dashboard/claims-insights/ClaimsInsightsProvidersTile";
import ClaimsInsightsSummaryTile from "@app/projects/network-assessment/pci-dashboard/claims-insights/ClaimsInsightsSummaryTile";

export const ClaimsInsightsDashboardDefaultView = (): JSX.Element => {
  const claimsInsightsContext = useContext(ClaimsInsightsDashboardContext);

  return (
    <React.Fragment>
      <div className="row">
        <ClaimsInsightsProvidersTile
          data={claimsInsightsContext.networkProvidersScores}
          effectivenessLoading={claimsInsightsContext.networkProvidersEffectivenessLoading}
          efficiencyLoading={claimsInsightsContext.networkProvidersEfficiencyLoading}
          onDashboardDetailsViewClick={claimsInsightsContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkTypeEnum.Network}
        />
        <ClaimsInsightsProvidersTile
          data={claimsInsightsContext.prospectProvidersScores}
          effectivenessLoading={claimsInsightsContext.prospectProvidersEffectivenessLoading}
          efficiencyLoading={claimsInsightsContext.prospectProvidersEfficiencyLoading}
          onDashboardDetailsViewClick={claimsInsightsContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkTypeEnum.Prospect}
        />
        <ClaimsInsightsProvidersTile
          data={claimsInsightsContext.marketProvidersScores}
          effectivenessLoading={claimsInsightsContext.marketProvidersEffectivenessLoading}
          efficiencyLoading={claimsInsightsContext.marketProvidersEfficiencyLoading}
          onDashboardDetailsViewClick={claimsInsightsContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkTypeEnum.Market}
        />
      </div>
      <div className="row">
        <ClaimsInsightsSummaryTile
          getSummaries={claimsInsightsContext.getSummaries}
          loading={claimsInsightsContext.countySummariesLoading}
          onSummaryDashboardDetailsViewClick={claimsInsightsContext.onSummaryDashboardDetailsViewClick}
          summaryModel={claimsInsightsContext.countySummariesModel}
          summaryType={PciDashboardSummaryType.County}
        />
        <ClaimsInsightsSummaryTile
          getSummaries={claimsInsightsContext.getSummaries}
          loading={claimsInsightsContext.specialtySummariesLoading}
          onSummaryDashboardDetailsViewClick={claimsInsightsContext.onSummaryDashboardDetailsViewClick}
          summaryModel={claimsInsightsContext.specialtySummariesModel}
          summaryType={PciDashboardSummaryType.Specialty}
        />
      </div>
    </React.Fragment>
  );
}

export default ClaimsInsightsDashboardDefaultView;
